/* eslint-disable jsx-a11y/no-access-key */
// import { DownOutlined, UserOutlined } from "@ant-design/icons"
import { Button, Layout, Spin, Form, Popover, Dropdown, Divider, Input, Modal, Row, Col, Badge } from "antd";
import { AccountBookingNew, BagFill, BuildingIconNew, CashBookingNew, CompanySettingIcon, DrsNew, InwordNew, LogoutIconNew, OutwardNew, ReportsIconNew, ForwardBooking, BellIcon } from "../config/IconsConfig";
import { observer } from "mobx-react";
import logo from "../images/corporateLogo.png"
import useStore from "../store";
import { Link, useHistory, useLocation } from "react-router-dom";
import Avatar from "antd/lib/avatar/avatar";
import userPic from "../images/user.png";
import { useEffect, useState } from "react";
import ChangePassword from "../page/ChangePassword";
import { vsmNotify } from "../config/messages/common";
import InputComponent from "./InputComponent";
import { checkStickerSeries, Userlevels } from "../utils/GlobalFunction";
import LogOutConfirmationModal from "../page/LogOutConfirmationModal";
import { Constant } from "../config/Constant";
import UserInfo from "../page/module/system/UserSetting/UserInfo";
import LocationsProfileInfo from "../page/module/system/LocationsProfile/index";
import CashBookingSettingsForm from "../page/module/Booking/CashBookingSettings/Component/CashBookingSettings";
// import DrsAddComponent from "../page/module/Booking/DrsWeb/component/AddComponent";
import StickerPreferenceComponent from "./AllocateOldSeriesComponent";
import ConsignmentTrackingComponent from "../page/module/Tracking/ConsignmentTrackingComponent";
import PacketTrackingComponent from "../page/module/Tracking/PacketTrackingComponent";
import BagTrackingComponent from "../page/module/Tracking/BagTrackingComponent";
import WarningComponent from "./WarningComponent"
import { Messages } from "../config/messages/messages";
import DrsSettingsComponent from '../page/module/Booking/DrsSettings/DrsSettings'
import { useIdleTimer } from "react-idle-timer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import PopupComponent from "./PopupComponent";
import AlertModalComponent from "./AlertModalComponent";
import ViewOutstanding from "../page/module/organization/TerminatedFranchisee/component/ViewOutstanding";
import moment from "moment";
import TrackShipment from "../page/module/Utilities/TrackShipment";

const HeaderComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		AUTH: { user, checkPrivileges, company, ChangeLocationData, setLogOutValues, unreadNotificationCount,setActiveNotificationMenu },
		ManageCentersStore,
		AUTH,
		ManageTrackingStore,
		ManageCashBookingSettingsStore: { ViewData },
		ManageTrackingStore: { getConsignmentTrackingData, getbagTrackingData, getPacketTrackingData },
		ManageTerminatedFranchiseeStore: {setOutstanding},
		AUTH: { reportsMenu },
	} = useStore();

	const [editProfileModal, seteditProfileModal] = useState(false);
	const [locationList, setLocationList] = useState([]);
	const [logOutModal, setLogOutModal] = useState(false)
	const [visible, setVisible] = useState(false);
	const [locationsProfileModal, setLocationsProfileModal] = useState(false);
	// const [drsaddModal, setDrsaddModal] = useState(false);
	const [stickerPreferenceModal, setStickerPreferenceModal] = useState(false);
	const [consignmentTrackingModal, setConsignmentTrackingModal] = useState(false);
	const [consignmentTrackingloading, setConsignmentTrackingloading] = useState(false);
	const [packetTrackingModal, setPacketTrackingModal] = useState(false);
	const [bagTrackingModal, setBagTrackingModal] = useState(false);
	const [warningModal, setWarningModal] = useState(false);
	const [messagesText, SetMessagesText] = useState()
	const [DrsSettingsModal, setDrsSettingsModal] = useState(false);
	const [alertModalOpen, setAlertModalOpen] = useState(false);
	const [viewOutstandingModal, setViewOutstandingModal] = useState(false);
	const [trackShipmentModal, setTrackShipmentModal] = useState(false);
	// const openEditProfileModal = () => {
	// 	seteditProfileModal(true);
	// };
	const [modalVisibilities, setModalVisibilities] = useState({});

	useEffect(() => {
		if (!AUTH?.communicationData?.popup_message) return;

		const intervals = [];
		
		AUTH.communicationData.popup_message.forEach((modal) => {
			// Handle "Once" frequency (frequency: 0) - show on every refresh
			if (modal.frequency === 0) {
				setModalVisibilities((prev) => ({ ...prev, [modal.id]: true }));
			} 
			// Handle recurring frequency (frequency > 0) - show once on login, then repeat
			else if (modal.frequency > 0) {
				const sessionKey = `popup_interval_${modal.id}`;
				const hasShownInSession = sessionStorage.getItem(sessionKey);
				
				const showModal = () => {
					setModalVisibilities((prev) => ({ ...prev, [modal.id]: true }));
				};
				
				// Show immediately only if not shown in this session
				if (!hasShownInSession) {
					showModal();
					sessionStorage.setItem(sessionKey, 'true');
				}
				
				// Set interval to show every X minutes
				const intervalId = setInterval(showModal, modal.frequency * 60 * 1000);
				intervals.push(intervalId);
			}
		});

		// Cleanup intervals on unmount
		return () => intervals.forEach(clearInterval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [AUTH?.communicationData?.popup_message]);

	// Function to close a modal
	const closeModal = (id) => {
		// Close the modal by updating the visibility state
		setModalVisibilities((prevVisibilities) => ({
			...prevVisibilities,
			[id]: false,
		}));
	};
	const openViewOutstandingModal = () => {
		let center = AUTH.user.default_location;
		let selectedCenter = AUTH.user.centers.find((item) => item.id === center)
		setOutstanding(
			{
				hub_id :selectedCenter.hub_id ,
				center_id : selectedCenter.id,
				from_date : Constant.FROM_DATE,
				to_date : moment(AUTH.user.system_date).format(Constant.PAYLOAD_DATE),
				report_type : 1,
				inv_type : 1,
				is_gst :1
			}
		)
		setViewOutstandingModal(true);
		setModalVisibilities(false)
    }

    const closeViewOutstandingModal = () => setViewOutstandingModal(false);
	const closeEditProfileModal = () => {
		seteditProfileModal(false);
	};

	const history = useHistory();
	const location = useLocation();

	// call logout function
	const openLogoutModal = (data) => {
		setLogOutModal(true)
		setLogOutValues(data)
	};
	const closeLogOutModal = () => setLogOutModal(false)


	// Open & Close  form for add new State
	const openLocationsProfile = (data) => {
		ManageCentersStore.ViewData(data.default_location).then((data) => {
			ManageCentersStore.setViewValues(data.view)
		}).then(() => {
			setLocationsProfileModal(true);
		});
	}
	const closeLocationsProfileModal = () => setLocationsProfileModal(false);

	//Open Cash Booking
	const openCashBooking = () => {
		history.replace("/bookings/cash-bookings-add");
	}

	//Open Account Booking
	const openAccountBooking = () => {
		history.replace("/bookings/account-bookings-add");
	}
	//Open Forward Booking
	const openForwardBooking = () => {
		history.replace("/bookings/forword-bookings-add");
	}

	const openDrsAdd = () => {
		// location.pathname.includes("/bookings/drs-add") ? window.location.reload() : history.replace("/bookings/drs-add");
		history.replace("/bookings/drs");
	}
	const openbag = () => {
		history.replace("/bookings/bags")
	}
	//Open Account Booking
	const openInward = () => {
		history.replace("/bookings/inward");
	}

	//Open Account Booking
	const openOutward = () => {
		history.replace("/bookings/outward");
	}

	const UserProfile = (
		<UserInfo setVisible={setVisible} />
	)

	useEffect(() => {
		if (user.level_id) {
			switch (user.level_id) {
				case 101:
					setLocationList(user.hos)
					break;
				case 111:
					setLocationList(user.hubs)
					break;
				case 121:
					let frs = user.frs.map((item) => {
						return {
							id: item.id,
							name: item.company,
							is_active: item.is_active,
							is_deleted: item.is_deleted,
							allow_ap: item?.allow_ap
						}
					});
					setLocationList(frs)
					break;
				case 131:
					let centers = user.centers.map((item) => {
						return {
							id: item.id,
							name: `${item.name} (${item?.owner_name})`,
							is_active: item.is_active,
							is_deleted: item.is_deleted,
							allow_ap: item?.allow_ap,
							mst_franchisee: item?.mst_franchisee,
							mst_hub: item?.mst_hub,
							fr_id: item?.fr_id,
							hub_id: item?.hub_id,
						}
					});
					let selectedCenter;
					if (user?.default_location) {
						let location = user.default_location;
						selectedCenter = user.centers.find((item) => item.id === location);
					}
					if (checkPrivileges('#12078#') && selectedCenter?.sp_flag === null) {
						setStickerPreferenceModal(true)
					}
					setLocationList(centers)
					break;
				case 141:
					setLocationList(user.clients)
					break;

				default:
					break;
			}
		}

	}, [user, checkPrivileges]);

	useEffect(() => {
		if (AUTH.alertModal === true) {
			setAlertModalOpen(true)
		}
	}, [AUTH.alertModal])

	/**
	 * This code is to set ideal for user
	 */
	let sessionTimeoutBuffer = Number((AUTH.company.branding.session_timeout_buffer * 60 * 1000))
	let sessionTime = Number((AUTH.company.branding.session_timeout * 60 * 1000));

	const [remaining, setRemaining] = useState(sessionTime);
	const [idealModal, setIdealModal] = useState(false);

	const idealModalClose = () => {
		if (AUTH && AUTH.user && AUTH.user.level_id !== Constant.ADMIN_USER) {
			setIdealModal(false);
			AUTH.doLogout().then((data) => {
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION,
				});
			});
			history.replace("/");
		}
	}
	const onIdle = () => {
		if (AUTH && AUTH.user && AUTH.user.level_id !== Constant.ADMIN_USER) {
			idealModalClose();
		}
	}

	const onActive = () => {
		setIdealModal(false)
	}

	const onPrompt = () => {
		if (AUTH && AUTH.user && AUTH.user.level_id !== Constant.ADMIN_USER) {
			setIdealModal(true);
		}
	}
	const {
		getRemainingTime,
		message,
		activate
	} = useIdleTimer({
		onIdle,
		onActive,
		onPrompt,
		timeout: sessionTime,
		promptBeforeIdle: sessionTimeoutBuffer,
		throttle: 500,
		crossTab: true,
		leaderElection: true,
	})

	const handleStillHere = () => {
		activate()
	}

	useEffect(() => {
		let interval = null;
		if (AUTH && AUTH.user && AUTH.user.level_id !== Constant.ADMIN_USER) {
			interval = setInterval(() => {
				message("active", true)
				setRemaining(Math.ceil(getRemainingTime() / 1000))
			}, 500);
		}
		return () => {
			interval && clearInterval(interval)
		}
	})

	const ChangeLocation = (e) => {
		//form.setFieldsValue({location_id:e})
		ChangeLocationData(e).then((data) => {
			vsmNotify.success({
				message: data.STATUS.NOTIFICATION[0],
			});
			if (location.pathname.includes(Constant.REPORTS_URL)) {
				history.replace("/dashboard");
			} else {
				window.location.reload();
			}
		}).catch((e) => {
			if (e.errors) {
				//form.setFields(e.errors);
			}
		});

	}
	const handleClickChange = (visible) => {
		setVisible(visible);
	};
	const [visibled, setVisibled] = useState(false)

	const openUtiliti = (data, typeid) => {
		if (typeid === "1070001" || typeid === "1070011") {
			ViewData(data, typeid === "1070011" ? 2 : 1).then(() => {
				setVisibled(true)
			})
		} else if (typeid === "1070061") {
			setDrsSettingsModal(true)
		} else {
			let URL = AUTH.user.utilities_menu.find(item => item.id === parseInt(typeid));
			history.replace(URL.controller);
		}
		//  else if (typeid === "1070031" || typeid === "1070071") {
		// 	let URL = AUTH.user.utilities_menu.find(item => item.id === parseInt(typeid));
		// 	history.replace(URL.controller);
		// } else if (typeid === "1070041") {
		// 	let URL = AUTH.user.utilities_menu.find(item => item.id === parseInt(typeid));
		// 	history.replace(URL.controller);
		// }
	}
	const closeUtiliti = () => {
		setVisibled(false)
		setDrsSettingsModal(false)
	}

	const menu = () => {
		let tempArray = []
		AUTH.user.utilities_menu && AUTH.user.utilities_menu.forEach((item) => {
			let tempObj = {}
			tempObj.key = item.id
			tempObj.label = item.name
			tempObj.onClick = ({ key }) => openUtiliti(AUTH.user.default_location, key)
			tempArray.push(tempObj)
		})
		return tempArray
	};
	const notificationMenu = () => {
		let tempArray = []
		AUTH.notificationMenu && AUTH.notificationMenu.forEach((item) => {
			let tempObj = {}
			tempObj.key = item.id
			tempObj.label= (
				<>
				  {item.name}				  
				 <Badge count={item.count} showZero/>
				</>
			  )
			tempObj.onClick = ({ key }) => openNotification(key)
			tempArray.push(tempObj)
		})
		return tempArray
	};
	const openNotification = (typeid) => {		
		let URL = AUTH.notificationMenu.find(item => item.id === parseInt(typeid));
		setActiveNotificationMenu(URL)
			history.replace(URL.controller);
		//  else if (typeid === "1070031" || typeid === "1070071") {
		// 	let URL = AUTH.user.utilities_menu.find(item => item.id === parseInt(typeid));
		// 	history.replace(URL.controller);
		// } else if (typeid === "1070041") {
		// 	let URL = AUTH.user.utilities_menu.find(item => item.id === parseInt(typeid));
		// 	history.replace(URL.controller);
		// }
	}
	// const closeNotification = () => {
	// 	setVisibled(false)
	// 	setDrsSettingsModal(false)
	// }
	const searchMenu = () => {
		let tempArray = []
		AUTH.user.search_menu && AUTH.user.search_menu.forEach((item) => {
			let tempObj = {}
			tempObj.key = item.id
			tempObj.label = item.name
			tempObj.onClick = ({ key }) => openSearchMenu(AUTH.user.default_location, key)
			tempArray.push(tempObj)
		})
		return tempArray
	};
	const openSearchMenu = (data, typeid) => {
		if(typeid === "1180081"){
			setTrackShipmentModal(true)
		} else {
			let URL = AUTH.user.search_menu.find(item => item.id === parseInt(typeid));
			history.replace(URL.controller);
		}
	}
	
	const closeSearchMenu= () => {
		setTrackShipmentModal(false)
	}
	const reportcontent = (
		<div className="nav-item py-1 REPORT" role="presentation" onClick={() => history.push('/reports')}>
			<ReportsIconNew title="Report" />
			<div className="head_right_icon">
				<h4>Report</h4>
				<em>(Alt+R)</em>
			</div>
		</div>
	)
	const drscontent = (
		<div className="nav-item py-1 DRS" role="presentation" onClick={() => { openDrsAdd(user) }}>
			<DrsNew title="DRS" />
			<div className="head_right_icon">
				<h4>DRS</h4>
				<em>(Alt+D)</em>
			</div>
		</div>
	);
	const bagcontent = (
		<div className="nav-item py-1 Bag" role="presentation" onClick={() => { openbag(user) }}>
			<BagFill title="BAG" />
			<div className="head_right_icon">
				<h4>BAG</h4>
				<em>(Alt+B)</em>
			</div>
		</div>
	);
	const Outwardcontent = (
		<div className="nav-item py-1 Outward" role="presentation" onClick={() => { openOutward(user) }}>
			<OutwardNew title="Outscan" />
			<div className="head_right_icon">
				<h4>Outscan</h4>
				<em>(Alt+O)</em>
			</div>
		</div>
	);
	const Inwardcontent = (
		<div className="nav-item py-1 Inward" role="presentation" onClick={() => { openInward(user) }}>
			<InwordNew title="Inscan" />
			<div className="head_right_icon">
				<h4>Inscan</h4>
				<em>(Alt+I)</em>
			</div>
		</div>
	);
	const AccountBookingcontent = (
		<div className="nav-item py-1 AccountBookingPopup" role="presentation" onClick={() => { openAccountBooking(user) }}>
			<AccountBookingNew title="Account Booking" />
			<div className="head_right_icon">
				<h4>Account Booking</h4>
				<em>(Alt+A)</em>
			</div>
		</div>
	);
	const ForwardingBookingcontent = (
		<div className="nav-item py-1 ForwardBookingPopup" role="presentation" onClick={() => { openForwardBooking(user) }}>
			<ForwardBooking />
			<div className="head_right_icon">
				<h4>Forwarding Booking</h4>
				<em>(Alt+F)</em>
			</div>
		</div>
	);
	const CashBookingcontent = (
		<div className="nav-item py-1 CashBookingPopup" role="presentation" onClick={() => { openCashBooking(user) }}>
			<CashBookingNew title="Cash Booking" />
			<div className="head_right_icon">
				<h4>Cash Booking</h4>
				<em>(Alt+C)</em>
			</div>
		</div>
	);
	const onSearch = async (value) => {
		setConsignmentTrackingloading(true)
		if (!value) {
			setWarningModal(true)
			SetMessagesText(Messages.SHIPMENT_REQUIRED)
			setConsignmentTrackingloading(false)
		}
		if (value && value.length === 13) {
			// if (parseInt(value.substr(6, 1)) === Constant.CASH || parseInt(value.substr(6, 1)) === Constant.ACCOUNT) {
			// 	let travalingData = await getConsignmentTrackingData({ con_no: value, purpose: "1" });
			// 	let bookingData = await getConsignmentTrackingData({ con_no: value, purpose: "2" });
			// 	let deliveryData = await getConsignmentTrackingData({ con_no: value, purpose: "3" });
			// 	let allData = { ...travalingData, ...bookingData, ...deliveryData };
			// 	await ManageTrackingStore.setConsignmentTrackingValues(allData);
			// 	setConsignmentTrackingModal(true);
			// }else 
			if (!checkStickerSeries(value)) {
				setConsignmentTrackingModal(true);
				setConsignmentTrackingloading(false)
				let travalingData = await getConsignmentTrackingData({ con_no: value, purpose: "1" });
				let bookingData = await getConsignmentTrackingData({ con_no: value, purpose: "2" });
				let deliveryData = await getConsignmentTrackingData({ con_no: value, purpose: "3" });
				let allData = { ...travalingData, ...bookingData, ...deliveryData };
				await ManageTrackingStore.setConsignmentTrackingValues(allData);
			}
			else {
				setWarningModal(true)
				SetMessagesText(Messages.INVALID_TRACKING_NUMBER)
				setConsignmentTrackingloading(false)
			}

		}
		else if (value && value.length === 11) {
			var value_split_con = value.substr(2, 1)
			if (value_split_con && parseInt(value_split_con) === Constant.CONSIGNMENT) {
				if ((checkPrivileges("#1070052#") || checkPrivileges("#1070053#"))) {
					setConsignmentTrackingModal(true);
					setConsignmentTrackingloading(false)
					let travalingData = await getConsignmentTrackingData({ con_no: value, purpose: "1" });
					let bookingData = await getConsignmentTrackingData({ con_no: value, purpose: "2" });
					let deliveryData = await getConsignmentTrackingData({ con_no: value, purpose: "3" });
					let allData = { ...travalingData, ...bookingData, ...deliveryData };
					await ManageTrackingStore.setConsignmentTrackingValues(allData);
				}
				else {
					setWarningModal(true)
					SetMessagesText(Messages.CON_TRACKING_DISABLED)
					setConsignmentTrackingloading(false)
				}
			} else if (parseInt(value_split_con) === Constant.BAG || parseInt(value_split_con) === Constant.BAG_TAG) {
				if ((checkPrivileges("#1070056#") || checkPrivileges("#1070057#"))) {
					getbagTrackingData({ bag_no: value, purpose: "1" }).then(() => {
						setBagTrackingModal(true)
						setConsignmentTrackingloading(false)
					})
						.catch((e) => {
							if (e.errors) {
								setWarningModal(true)
								SetMessagesText(e.errors[0].errors)
								setConsignmentTrackingloading(false)
							}
						})
				}
				else {
					setWarningModal(true)
					SetMessagesText(Messages.BAG_TRACKING_DISABLED)
					setConsignmentTrackingloading(false)
				}

			} else if (parseInt(value_split_con) === Constant.PACKET) {
				if ((checkPrivileges("#1070054#") || checkPrivileges("#1070055#"))) {
					getPacketTrackingData({ packet_no: value, purpose: "1" }).then(() => {
						setPacketTrackingModal(true)
						setConsignmentTrackingloading(false)
					})
						.catch((e) => {
							if (e.errors) {
								setWarningModal(true)
								SetMessagesText(e.errors[0].errors)
								setConsignmentTrackingloading(false)
							}
						})
				}
				else {
					setWarningModal(true)
					SetMessagesText(Messages.PACKET_TRACKING_DISABLED)
					setConsignmentTrackingloading(false)
				}
			}
			else {
				setWarningModal(true)
				SetMessagesText(Messages.INVALID_TRACKING_NUMBER)
				setConsignmentTrackingloading(false)
			}
		}
		else {
			setWarningModal(true)
			SetMessagesText(Messages.SHIPMENT_LEN_ERROR)
			setConsignmentTrackingloading(false)
		}
	}
	const closeConsignmentTrackingModal = () => {
		setConsignmentTrackingModal(false)
		form.resetFields(['track_consignment'])

	}
	const openBagTrackingModal = (data) => {
		if ((checkPrivileges("#1070056#") || checkPrivileges("#1070057#"))) {
			getbagTrackingData({ bag_no: data.parent_item_no, purpose: "1" }).then(() => {
				setBagTrackingModal(true);
			})
		}
		else {
			setWarningModal(true)
			SetMessagesText(Messages.BAG_TRACKING_DISABLED)
		}
	};
	const closeBagTrackingModal = () => {
		setBagTrackingModal(false)
		form.resetFields(['track_consignment'])
	}
	const opencketTrackingModal = (data) => {
		if ((checkPrivileges("#1070054#") || checkPrivileges("#1070055#"))) {
			getPacketTrackingData({ packet_no: data.parent_item_no, purpose: "1" }).then(() => {
				setPacketTrackingModal(true);
			})
		}
		else {
			setWarningModal(true)
			SetMessagesText(Messages.PACKET_TRACKING_DISABLED)
		}
	};
	const closePacketTrackingModal = () => {
		setPacketTrackingModal(false)
		form.resetFields(['track_consignment'])
	}
	const closeWarningModal = () => {
		setWarningModal(false)
		form.resetFields(['track_consignment'])
	}
	const closeAlertModalOpen = () => {
		setAlertModalOpen(false)
		if (AUTH.user?.lock?.IsManualLock !== 1) {
			history.push({
				pathname: "/lock/tracking",
			});
		}
	}
	return (
		<Layout.Header className="site__header">
			<CashBookingSettingsForm visible={visibled} close={closeUtiliti} />
			<div className="navLogo">
				<Link to="/dashboard" className="logo_wrapper">
					<img src={company ? company.branding.logo : logo} alt="Logo" />
				</Link>
			</div>

			<div className="right-main-header">
				<div className="rightHeader">
					<div className="d-flex align-items-center">
						{props.collapsed ? (
							<Button
								className="trigger toggle_btn toggle_right"
								onClick={() => {
									props.setCollapsed(false);
								}}
							>
								<span></span>
								<span></span>
								<span></span>
							</Button>
						) : (
							<Button
								className="trigger toggle_btn"
								onClick={() => {
									props.setCollapsed(true);
								}}
							>
								<span></span>
								<span></span>
								<span></span>
							</Button>
						)}
					</div>
					<div className="header_right">
						{(checkPrivileges('#1070052#') || checkPrivileges('#1070053#') || checkPrivileges('#1070054#') || checkPrivileges('#1070055#') || checkPrivileges('#1070056#') || checkPrivileges('#1070057#')) &&
							<div className="header-dropdown header-dropdown-input">
								<Form
									form={form}
									labelCol={{ span: 24 }}
								>
									<Form.Item name="track_consignment">
										<Input.Search loading={consignmentTrackingloading} allowClear name="track_consignment" placeholder="Track Consignment/Packet/Bag" onSearch={onSearch} />
									</Form.Item>
								</Form>
							</div>
						}
						{checkPrivileges('#1060002#') &&
							<Popover content={CashBookingcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="c" onClick={() => { openCashBooking(user) }}>
										<CashBookingNew title="Cash Booking" />
									</div>
								</div>
							</Popover>
						}
						{checkPrivileges('#1060002#') &&
							<Popover content={AccountBookingcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="a" onClick={() => { openAccountBooking(user) }}>
										<AccountBookingNew title="Account Booking" />
									</div>
								</div>
							</Popover>
						}
						{/* {checkPrivileges('#1060122#') &&
							<Popover content={Deliverycontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="d" onClick={() => { openLocationsProfile(user) }}>
										<DeliveryNew title="Delivery" />
									</div>
								</div>
							</Popover>
						} */}
						{checkPrivileges('#1060102#') &&
							<Popover content={Inwardcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="i" onClick={() => { openInward(user) }}>
										<InwordNew title="Inscan" />
									</div>
								</div>
							</Popover>
						}
						{checkPrivileges('#1060082#') &&
							<Popover content={Outwardcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="o" onClick={() => { openOutward(user) }}>
										<OutwardNew title="Outscan" />
									</div>
								</div>
							</Popover>
						}
						{checkPrivileges('#1060052#') &&
							<Popover content={bagcontent} overlayClassName="Header_main_icon">
								{/**Pending to set reditrect */}
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="b" onClick={() => { openbag() }}>
										<BagFill title="BAG" />
									</div>
								</div>
							</Popover>
						}
						{checkPrivileges('#1060122#') &&
							<Popover content={drscontent} overlayClassName="Header_main_icon">
								{/**Pending to set reditrect */}
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="d" onClick={() => { openDrsAdd() }}>
										<DrsNew title="DRS" />
									</div>
								</div>
							</Popover>
						}
						{checkPrivileges('#1060241#') && (AUTH?.user.level_id !== Constant.ADMIN_USER) && ((AUTH?.user.level_id === Constant.LOCATION_USER) ? (AUTH?.user?.contracts?.rp_id === 2 || AUTH?.user?.contracts?.rp_id === 4) : true) &&
							<Popover content={ForwardingBookingcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<div className="head_right_icon" accessKey="f" onClick={() => { openForwardBooking(user) }}>
										<ForwardBooking />
									</div>
								</div>
							</Popover>
						}
						{reportsMenu && reportsMenu.length > 0 &&
							<Popover content={reportcontent} overlayClassName="Header_main_icon">
								<div className="notificcation_head">
									<span className="head_right_icon" accessKey="r" onClick={() => history.push('/reports')}>
										<ReportsIconNew title="Report" />
									</span>
								</div>
							</Popover>
						}
						{AUTH.user.search_menu?.length !== 0 && (
							<div className="notificcation_head">					
									<Dropdown menu={{ items: searchMenu() }} placement="bottom" arrow="true" trigger="click" overlayClassName="TopnotificationMenu">
										<span
										className="head_right_icon head_right_search_icon">											
											<FontAwesomeIcon icon={faSearch} />
										</span>
									</Dropdown>
							</div>
						)}
						<div className="header-dropdown" id="parent_location_id">
							{(Userlevels.includes(user.level_id)) &&
								<Form.Item>
									<InputComponent
										type="select"
										required
										autoComplete="chrome-off"
										placeholder="Select Level"
										name="location_id"
										getPopupContainer={() => document.getElementById('parent_location_id')}
										onChange={(e) => {
											ChangeLocation(e);
										}}
										disabled={user && user.level_id === Constant.AGENCY_USER ? true : false}
										notFoundContent={
											locationList ? <Spin size="small" /> : "No Record Found."
										}
										defaultValue={user.default_location}
										options={{
											values: locationList,
											value_key: "id",
											text_key: "name",

										}}
									/>
								</Form.Item>
							}
						</div>
						{/* {AUTH.user.level_id === Constant.LOCATION_USER && (
							<div className="notificcation_head">
								<span
									className="head_right_icon"
									onClick={() => {
										openNotificationModal();
									}}
								>
									{unreadNotificationCount > 0 && <span className="notificationCount">{unreadNotificationCount}</span>}
									<BellIcon />
								</span>
							</div>
						)} */}
							{AUTH.notificationMenu?.length !== 0 && <div className="notificcation_head">							
									
									<Dropdown menu={{ items: notificationMenu() }} placement="bottom" arrow="true" trigger="click" overlayClassName="TopnotificationMenu">
										<span
										className="head_right_icon"
									>
											{unreadNotificationCount > 0 && <span className="notificationCount">{unreadNotificationCount}</span>}
											<BellIcon />
										</span>
									</Dropdown>
							</div>}
						{AUTH.user.utilities_menu.length !== 0 && (
							<div className="notificcation_head">
								<span
									className="head_right_icon"
								>
									<Dropdown menu={{ items: menu() }} placement="bottom" arrow="true" trigger="click">
										<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 95.71 94.24"><defs><style></style></defs><path className="cls-1" d="M79.92,21.79Q61.35,11.1,42.81.37a2.2,2.2,0,0,0-2.48,0Q21.92,11.07,3.49,21.66A2.41,2.41,0,0,0,2.14,24q0,23.07,0,46.15a2.49,2.49,0,0,0,1.43,2.43Q22,83.21,40.42,93.88a2.11,2.11,0,0,0,2.38,0c2.74-1.61,5.49-3.18,8.22-4.76l4.9-2.82c-.55-.54-1.09-1.09-1.62-1.63a3.78,3.78,0,0,1-.38-.43L43,90.54V89.4Q43,68.2,43,47a1.51,1.51,0,0,1,.9-1.53Q60.45,36,77,26.36c.36-.21.73-.4,1.18-.64v14.9h1.66a5.06,5.06,0,0,1,1.17.14q0-8.49,0-17A2,2,0,0,0,79.92,21.79ZM57.5,12.05c1.94,1.17,3.92,2.29,6,3.5-.26.19-.44.36-.64.48L29,35.56a1.33,1.33,0,0,1-1,.19c-2.19-1.21-4.34-2.47-6.61-3.79l8.94-5.16Q43.15,19.44,55.9,12A1.37,1.37,0,0,1,57.5,12.05ZM26.92,38.81q0,12.27,0,24.54s0,0-.11.21c-.78-.86-1.52-1.65-2.22-2.48a1.67,1.67,0,0,0-2.19-.52c-.74.34-1.51.61-2.33.94V34.39c2.25,1.29,4.43,2.52,6.56,3.78A.8.8,0,0,1,26.92,38.81ZM16.67,17.29q12.06-7,24.14-14a1.38,1.38,0,0,1,1.61,0C46.19,5.56,50,7.74,53.9,10l-3.4,2q-15.49,9-31,17.92a1.44,1.44,0,0,1-1.69,0c-3.75-2.21-7.53-4.37-11.45-6.64ZM40.2,53.4V90.45c-.3-.14-.53-.23-.75-.35Q22.56,80.35,5.68,70.62a1.23,1.23,0,0,1-.76-1.21q0-21.49,0-43v-.7c.35.17.61.28.85.42,3.57,2.06,7.13,4.14,10.71,6.18a1.3,1.3,0,0,1,.74,1.32c0,9.74,0,19.48,0,29.22,0,2,.76,2.51,2.59,1.77.79-.32,1.6-.62,2.37-1a.82.82,0,0,1,1.17.27c1.18,1.39,2.39,2.73,3.58,4.11a1.59,1.59,0,0,0,1.91.65c.76-.31.86-1,.86-1.72q0-12.89,0-25.76V39.92c3.48,2,6.79,3.92,10.09,5.87a1.27,1.27,0,0,1,.39,1C40.23,49,40.2,51.19,40.2,53.4ZM72.4,25.83q-15,8.66-30,17.32a1.44,1.44,0,0,1-1.69,0c-2.83-1.68-5.7-3.31-8.56-5l-1-.64,15.75-9.09c6.21-3.59,12.44-7.17,18.64-10.79a1.43,1.43,0,0,1,1.68,0c3.15,1.86,6.32,3.68,9.62,5.58Z" transform="translate(-2.14 0)" /><path className="cls-1" d="M76.42,57.32a10.67,10.67,0,0,0-7.74,3.13,10.72,10.72,0,0,0-.05,15,10.5,10.5,0,0,0,7.55,3.18h0a10.63,10.63,0,0,0,.21-21.26Zm6.31,15.19a7.94,7.94,0,0,1-3.52,2.81,5.37,5.37,0,0,1-2,.53h0a3.38,3.38,0,0,0-.53.05,1.68,1.68,0,0,1-.43,0A7.93,7.93,0,0,1,69,71.27,7.79,7.79,0,0,1,68.3,67a4.21,4.21,0,0,1,.16-.89l.17-.19,0-.15a.82.82,0,0,0,0-.21s0-.12,0-.14a7.83,7.83,0,0,1,4.49-4.8,9.87,9.87,0,0,1,1.76-.46l.26-.05a5.32,5.32,0,0,1,1.29-.1A7.94,7.94,0,0,1,82,62.5a8,8,0,0,1,.72,10Z" transform="translate(-2.14 0)" /><path className="cls-1" d="M79.92,21.79Q61.35,11.1,42.81.37a2.2,2.2,0,0,0-2.48,0Q21.92,11.07,3.49,21.66A2.41,2.41,0,0,0,2.14,24q0,23.07,0,46.15a2.49,2.49,0,0,0,1.43,2.43Q22,83.21,40.42,93.88a2.11,2.11,0,0,0,2.38,0c2.74-1.61,5.49-3.18,8.22-4.76l4.9-2.82c-.55-.54-1.09-1.09-1.62-1.63a3.78,3.78,0,0,1-.38-.43L43,90.54V89.4Q43,68.2,43,47a1.51,1.51,0,0,1,.9-1.53Q60.45,36,77,26.36c.36-.21.73-.4,1.18-.64v14.9h1.66a5.06,5.06,0,0,1,1.17.14q0-8.49,0-17A2,2,0,0,0,79.92,21.79ZM57.5,12.05c1.94,1.17,3.92,2.29,6,3.5-.26.19-.44.36-.64.48L29,35.56a1.33,1.33,0,0,1-1,.19c-2.19-1.21-4.34-2.47-6.61-3.79l8.94-5.16Q43.15,19.44,55.9,12A1.37,1.37,0,0,1,57.5,12.05ZM26.9,63.35s0,0-.11.21c-.78-.86-1.52-1.65-2.22-2.48a1.67,1.67,0,0,0-2.19-.52c-.74.34-1.51.61-2.33.94V34.39c2.25,1.29,4.43,2.52,6.56,3.78a.8.8,0,0,1,.31.64Q26.92,51.08,26.9,63.35ZM16.67,17.29q12.06-7,24.14-14a1.38,1.38,0,0,1,1.61,0C46.19,5.56,50,7.74,53.9,10l-3.4,2q-15.49,9-31,17.92a1.44,1.44,0,0,1-1.69,0c-3.75-2.21-7.53-4.37-11.45-6.64ZM72.4,25.83q-15,8.66-30,17.32a1.44,1.44,0,0,1-1.69,0c-2.83-1.68-5.7-3.31-8.56-5l-1-.64,15.75-9.09c6.21-3.59,12.44-7.17,18.64-10.79a1.43,1.43,0,0,1,1.68,0c3.15,1.86,6.32,3.68,9.62,5.58Z" transform="translate(-2.14 0)" /><path className="cls-1" d="M97.85,65.27l-.3,0-1-.17-1.38-.23-.78-.12-1.09-.17a1.29,1.29,0,0,1-1.07-1,16,16,0,0,0-1.55-3.75,1.41,1.41,0,0,1,.09-1.64l1-1.43,1.59-2.2-3.08-3.08-.63-.63-.07-.08s0,0-.06,0l-3.64,2.63a1.35,1.35,0,0,1-1.49.1A16.55,16.55,0,0,0,80.67,52a1.36,1.36,0,0,1-1.07-1.32c0-.31-.09-.61-.14-.92l-.23-1.38c-.12-.67-.24-1.35-.34-2H74.17c-.22,0-.43,0-.65,0-.14.78-.26,1.56-.38,2.34,0,.28-.08.56-.12.85s-.12.84-.19,1.26A1.44,1.44,0,0,1,71.74,52,15.46,15.46,0,0,0,68,53.5a1.36,1.36,0,0,1-1.52-.08l-1.42-1c-.76-.54-1.52-1.09-2.27-1.65L59,54.53c.22.29.43.59.64.88l.87,1.21c.38.51.75,1,1.13,1.55a1.3,1.3,0,0,1,.16,1.48,19.17,19.17,0,0,0-1.66,4,1.3,1.3,0,0,1-1.09.95l-.45.08-.57.1-3.43.51h0V70.6l.46.08,3.06.49,1,.16a1.38,1.38,0,0,1,1.13,1,19,19,0,0,0,1.62,3.9,1.31,1.31,0,0,1-.11,1.45l-.68.94c-.65.92-1.32,1.84-2,2.74h0l0,0q1.9,1.86,3.78,3.76c.77-.57,1.49-1.09,2.2-1.6l1.39-1A1.45,1.45,0,0,1,68,82.39a16.86,16.86,0,0,0,3.74,1.55,1.5,1.5,0,0,1,1.12,1.35c.08.7.19,1.41.31,2.11,0,.27.08.54.13.81.08.47.16.93.22,1.4h5.36c.05-.36.11-.66.16-1l.19-1.15c.13-.75.26-1.51.37-2.27a1.43,1.43,0,0,1,1.14-1.3,16.29,16.29,0,0,0,3.63-1.51,1.39,1.39,0,0,1,1.55.07L88.08,84l1.47,1.06,3.82-3.77-.57-.8-2-2.71A1.49,1.49,0,0,1,90.74,76a14.44,14.44,0,0,0,1.46-3.6,1.42,1.42,0,0,1,1.16-1.07l.75-.13.6-.09,3.15-.5V69C97.86,67.79,97.86,66.53,97.85,65.27Zm-18.64,10a5.37,5.37,0,0,1-2,.53h0a3.38,3.38,0,0,0-.53.05,1.68,1.68,0,0,1-.43,0A7.93,7.93,0,0,1,69,71.27,7.79,7.79,0,0,1,68.3,67a4.21,4.21,0,0,1,.16-.89l.17-.19,0-.15a.82.82,0,0,0,0-.21s0-.12,0-.14a7.83,7.83,0,0,1,4.49-4.8,9.87,9.87,0,0,1,1.76-.46l.26-.05a5.32,5.32,0,0,1,1.29-.1A7.94,7.94,0,0,1,82,62.5a8,8,0,0,1,.72,10A7.94,7.94,0,0,1,79.21,75.32Z" transform="translate(-2.14 0)" /></svg>
									</Dropdown>
								</span>
							</div>
						)}
						{checkPrivileges("#11001#") && (
							<div className="notificcation_head">
								<span
									className="head_right_icon"
									onClick={() => history.push("/system/configuration")}
								>
									<CompanySettingIcon />
								</span>
							</div>
						)}
						{((checkPrivileges("#12063#") || checkPrivileges("#12065#") || checkPrivileges("#12066#")) && (user.level_id === Constant.LOCATION_USER)) && (
							<div className="notificcation_head">
								<div className="head_right_icon" onClick={() => { openLocationsProfile(user) }}>
									<BuildingIconNew />
								</div>
							</div>
						)}
						{(checkPrivileges("#13002#")) && (
							<div className="notificcation_head">
								<div className="user_profile_sb">
									<Popover open={visible} overlayClassName="UserProfileDesign" placement="bottomRight" content={UserProfile} trigger="click" onOpenChange={handleClickChange}>
										<span
										//onClick={() => history.push("/system/change-profile")}
										>
											<Avatar src={user ? Constant.S3BUCKET_API_BASEURL + user.avatar : userPic} />
										</span>
									</Popover>
								</div>
							</div>
						)}
						<div className="notificcation_head">
							<span
								className="head_right_icon head_right_icon_logout"
								onClick={() => {
									openLogoutModal(user);
								}}
							>
								<LogoutIconNew />
							</span>
						</div>
					</div>
				</div>
				{AUTH && AUTH.communicationData && AUTH.communicationData.scrolling_message && AUTH.communicationData.scrolling_message.length > 0 &&
					<>
						<div class="scrolling-message">
							<div class="scrolling-content">
								{AUTH.communicationData.scrolling_message.map((item, index) => (
									<span key={index} className="scrolling-item">{item}</span>
								))}
							</div>
						</div>
						<Divider className="m-5" />
					</>
				}
				{AUTH &&
					AUTH.communicationData &&
					AUTH.communicationData.popup_message &&
					AUTH.communicationData.popup_message.length > 0 && (
						<div width="100%">
							{AUTH.communicationData.popup_message.map((modal, index) => (
								<PopupComponent
									key={index}
									modalTitle={modal.title}
									modalContent={modal.message}
									modalImage={modal.att_file}
									modalData={modal}
									visible={modalVisibilities[modal.id] || false}
									onClose={() => closeModal(modal.id)}
									onViewOutstanding ={() => openViewOutstandingModal()}
								/* visible={bookingWarningModel} close={closeBookingWarningModal} message={errorMessage} field={errorFields} */
								/>
							))}
						</div>
					)
				}
			</div>
			<ChangePassword
				visible={editProfileModal}
				close={closeEditProfileModal}
			/>
			<LogOutConfirmationModal visible={logOutModal} close={closeLogOutModal} />
			<LocationsProfileInfo visible={locationsProfileModal} close={closeLocationsProfileModal} />
			{/* <DrsAddComponent visible={drsaddModal} close={closeDrsaddModal} /> */}
			<StickerPreferenceComponent visible={stickerPreferenceModal} />
			<ConsignmentTrackingComponent visible={consignmentTrackingModal} close={closeConsignmentTrackingModal} openBagTrackingModal={openBagTrackingModal} opencketTrackingModal={opencketTrackingModal} />
			<PacketTrackingComponent visible={packetTrackingModal} close={closePacketTrackingModal} />
			<BagTrackingComponent visible={bagTrackingModal} close={closeBagTrackingModal} />
			<WarningComponent visible={warningModal} close={closeWarningModal} title={"Alert"} messages={messagesText} className="statusModal" />
			<DrsSettingsComponent visible={DrsSettingsModal} close={closeUtiliti} />
			<TrackShipment visible={trackShipmentModal} close={closeSearchMenu} setConsignmentTrackingModal={setConsignmentTrackingModal} setWarningModal={setWarningModal} SetMessagesText={SetMessagesText} />
			<ViewOutstanding 
				visible={viewOutstandingModal} 
				close={closeViewOutstandingModal} 
				 />
			<AlertModalComponent 
				visible={alertModalOpen}
				close={closeAlertModalOpen}
				title={"Alert"}
				messages={
					AUTH.user?.lock?.IsManualLock && AUTH.user.lock.IsManualLock === 1 ?
					 "Your tracking has been locked. " 
					 :
					  "Your " + (AUTH.user?.lock?.lck_int_tracking === 1 ? "internal tracking  " : "") + (AUTH.user?.lock?.lck_int_tracking === 1 && AUTH.user?.lock?.lck_tracking === 1 ? "and the " : "") + (AUTH.user?.lock?.lck_tracking === 1 ? "tracking on website (http://www.shreenandancourier.com/) " : "") + "is locked due to " + AUTH.user?.lock?.LckName + ". Click on Ok button to view " + AUTH.user?.lock?.LckName + "."
					}
				note={AUTH.user?.lock?.NoteRet}
			/>
			<Modal
				centered
				className="deleteModal"
				title={`Alert !`}
				open={idealModal}
				closeIcon={<FontAwesomeIcon icon={faTimes} />}
				onCancel={idealModalClose}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				footer={[
					<Button
						key="2"
						htmlType="button"
						className="cancelBtn mr-35"
						onClick={idealModalClose}
					>
						No
					</Button>,
					<Button
						key="1"
						htmlType="button"
						type="danger"
						onClick={handleStillHere}
					>
						Yes
					</Button>,
				]}
			>
				<Row align="middle">
					<Col span={24} className="text-center">
						<h3>
							<span className="warning_color"><FontAwesomeIcon className="" icon={faExclamationTriangle} /></span> Are you still here?
							<p className="info_text_add" style={{ color: `#ff3131` }}><b>Notes: </b>Logging out in {remaining} seconds.</p>
						</h3>
					</Col>
				</Row>
			</Modal>
		</Layout.Header>
	);
});

export default HeaderComponent;
